
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginForm from './components/main/Login/LoginForm'
import AddOrEditEventForm from "./components/main/EventList/AddOrEditEventForm";
import EventList from "./components/main/EventList/EventList";
import UserForm from "./components/main/EventList/userForm";
function App() {
  return (
    <BrowserRouter>

      <Routes>
         <Route path="/" element={<LoginForm />} />
        <Route path="/eventlist" element={<EventList/>} />
        <Route path="/eventform" element={<AddOrEditEventForm />} />
        <Route path="/eventuserform" element={<UserForm />} />
      </Routes>

    </BrowserRouter>
  );
}

export default App;
